const configuredApiUrl = process.env.REACT_APP_API_URL?.trim();

const productionApiUrl = 'https://helportattendance.com/api.php';

const productionAttendanceUrl = 'https://helportattendance.com/attendance_api.php';

const productionPortalUrl = 'https://helportattendance.com/employee_portal.php';

const API_URL = configuredApiUrl || productionApiUrl;



const PORTAL_UPLOAD_STEPS =

  'Sa cPanel → File Manager → public_html (kung saan naka-upload ang api.php), i-upload ang employee_portal.php mula sa rfid-system/backend/. Huwag ilagay sa React build folder.';



/** Employee portal can use a dedicated PHP file on the server. */

export function getPortalApiUrl(baseUrl = API_URL) {

  const configuredPortal = process.env.REACT_APP_PORTAL_API_URL?.trim();

  if (configuredPortal) return configuredPortal;



  if (/employee_portal\.php/i.test(baseUrl)) return baseUrl;



  try {

    const url = new URL(baseUrl);

    url.pathname = url.pathname.replace(/[^/]+$/, 'employee_portal.php');

    url.search = '';

    return url.toString();

  } catch {

    return productionPortalUrl;

  }

}



/** Safely parse a fetch Response as JSON — never throws on empty/HTML bodies. */

export async function parseJsonResponse(response) {

  const text = await response.text();

  if (!text || !text.trim()) {

    return null;

  }

  if (/^\s*</.test(text)) {

    return null;

  }

  try {

    return JSON.parse(text);

  } catch {

    return null;

  }

}



async function safeFetch(url) {

  try {

    const response = await fetch(url);

    const data = await parseJsonResponse(response);

    return { response, data, error: null };

  } catch (error) {

    return { response: null, data: null, error };

  }

}



/**

 * Confirms employee_portal.php is available on the server.

 */

export async function verifyPortalApi(baseUrl = getPortalApiUrl()) {

  const join = (action) => {

    const separator = baseUrl.includes('?') ? '&' : '?';

    return `${baseUrl}${separator}action=${action}`;

  };



  const health = await safeFetch(join('health'));

  if (health.data?.system === 'employee_portal') {

    return { ok: true, url: baseUrl };

  }



  const list = await safeFetch(join('get_employee_portals'));

  if (Array.isArray(list.data?.accounts)) {

    return { ok: true, url: baseUrl };

  }



  if (health.data?.system === 'rfid_attendance') {

    return { ok: true, url: baseUrl };

  }



  if (Array.isArray(list.data?.logs) && list.data?.status === 'success') {

    return {

      ok: false,

      url: baseUrl,

      message: 'Lumang api.php pa rin ang nasa server. I-replace ang api.php sa public_html gamit ang updated file mula sa rfid-system/backend/.',

    };

  }



  if (health.error || list.error) {

    return {

      ok: false,

      url: baseUrl,

      message: PORTAL_UPLOAD_STEPS,

    };

  }



  return {

    ok: false,

    url: baseUrl,

    message: PORTAL_UPLOAD_STEPS,

  };

}



/**

 * Confirms the server is running the RFID Attendance API (not Job Application api.php).

 */

export async function verifyAttendanceApi(baseUrl = API_URL) {

  const join = (action) => {

    const separator = baseUrl.includes('?') ? '&' : '?';

    return `${baseUrl}${separator}action=${action}`;

  };



  const health = await safeFetch(join('health'));

  if (health.data?.system === 'rfid_attendance') {

    return {

      ok: true,

      version: health.data.version || '2.0',

      url: baseUrl,

      legacy: false,

    };

  }



  const portal = await safeFetch(join('get_employee_portals'));

  if (Array.isArray(portal.data?.accounts)) {

    return { ok: true, version: 'current', url: baseUrl, legacy: false };

  }



  // Old api.php ignores ?action= and always returns logs — attendance still works.

  if (Array.isArray(portal.data?.logs) && portal.data?.status === 'success') {

    return {

      ok: true,

      version: 'legacy',

      url: baseUrl,

      legacy: true,

      message: '',

    };

  }



  if (

    portal.data?.message === 'Invalid action specified.' ||

    portal.data?.message?.includes?.('Invalid action')

  ) {

    return {

      ok: false,

      reason: 'wrong_api',

      url: baseUrl,

      legacy: false,

      message:

        'Maling API ang nasa server (Job Application API). Para sa RFID Attendance, i-upload ang api.php mula sa rfid-system/backend/.',

    };

  }



  if (health.error || portal.error) {

    return {

      ok: false,

      reason: 'network',

      url: baseUrl,

      legacy: false,

      message: `Hindi makakonekta sa ${baseUrl}`,

    };

  }



  if (!portal.data && !health.data) {

    return {

      ok: false,

      reason: 'missing',

      url: baseUrl,

      legacy: false,

      message: `Walang valid API response mula sa ${baseUrl}.`,

    };

  }



  return {

    ok: false,

    reason: 'unknown',

    url: baseUrl,

    legacy: false,

    message: `Hindi makilala ang API sa ${baseUrl}.`,

  };

}



/**

 * Pick the best working API URL: configured → api.php → attendance_api.php

 */

export async function resolveWorkingApiUrl() {

  const candidates = [

    configuredApiUrl,

    productionApiUrl,

    productionAttendanceUrl,

  ].filter(Boolean);



  const unique = [...new Set(candidates)];

  for (const url of unique) {

    const result = await verifyAttendanceApi(url);

    if (result.ok) {

      return { url, ...result };

    }

  }



  return { url: API_URL, ok: false, reason: 'none', legacy: false };

}



export default API_URL;


